import React from 'react';
import styled from "styled-components";
import {useAppSelector} from "../../hooks/hooks";

const InformationBlock: React.FC = () => {
    const slideState = useAppSelector((state) => state.slide)
    const codeStatus = useAppSelector((state) => state.tutorial.status)

    return (
        <Container>
            {slideState.completed_at &&
                <P>Code is claimed!<br/>
                    You have claimed this code</P>
            }
            {!slideState.completed_at && !codeStatus &&
                <P>Wrong code. Try again!</P>
            }
        </Container>
    );
};

export default InformationBlock;

const Container = styled.div`
    padding: 16px 24px;
`;
const P = styled.p`
    font-size: 1.9vh;
    font-weight: 700;
    margin: 0;
`;
